import { render, staticRenderFns } from "./AboutSmp.vue?vue&type=template&id=9be71550&scoped=true&"
import script from "./AboutSmp.vue?vue&type=script&lang=js&"
export * from "./AboutSmp.vue?vue&type=script&lang=js&"
import style0 from "./AboutSmp.vue?vue&type=style&index=0&id=9be71550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be71550",
  null
  
)

export default component.exports